export const CREDENTIAL_VERIFICATION_STATUS = {
  PENDING: 'PENDING',
  VERIFYING: 'VERIFYING',
  VERIFIED: 'VERIFIED',
  FAILED: 'FAILED',
} as const;

export type CredentialVerificationStatus =
  (typeof CREDENTIAL_VERIFICATION_STATUS)[keyof typeof CREDENTIAL_VERIFICATION_STATUS];

export const isCredentialVerificationInProgress = ({
  status,
}: {
  status?: CredentialVerificationStatus | string | null;
}): boolean => {
  return (
    status === CREDENTIAL_VERIFICATION_STATUS.PENDING ||
    status === CREDENTIAL_VERIFICATION_STATUS.VERIFYING
  );
};

export const isCredentialVerificationCompleted = ({
  status,
}: {
  status?: CredentialVerificationStatus | string | null;
}): boolean => {
  return (
    status === CREDENTIAL_VERIFICATION_STATUS.VERIFIED ||
    status === CREDENTIAL_VERIFICATION_STATUS.FAILED
  );
};
